import Tizen from './Tizen';
//import Orsay from './Orsay';
import Orsay from './Tizen';
import LG from './LG';
import { v4 as uuidv4 } from 'uuid';

const DEVICE_TYPE = {
  TIZEN: 'samsung-tizen',
  ORSAY: 'samsung-orsay',
  LG: 'lg',
  DEFAULT: 'default',
};

export default class Device {
  static get apis() {
    console.log("--------------------------------------apis 3 detected");
    if(window.isTizen)
      return {
        tvwindow: Tizen.tvwindow,
        b2bcontrol: Tizen.b2bControl,
        b2bpower: Tizen.b2bPower,
      };
    console.log("--------------------------------------apis 2 detected");
    if(window.isLG)
      return {
        tvwindow: LG.tvwindow,
        b2bcontrol: LG.b2bControl,
        b2bpower: LG.b2bPower,
        b2bmedia: LG.b2bMedia,
      };
    console.log("--------------------------------------apis 1 detected");
    if(window.isOrsay)
      return {
        tvwindow: Orsay.tvwindow,
        b2bcontrol: Orsay.b2bControl,
        b2bpower: Orsay.b2bPower,
      };
    console.log("--------------------------------------apis 0 detected");
    return {};
  }

  static get type() {
    if(window.isTizen) return DEVICE_TYPE.TIZEN;
    // window.lgVersion wird vom LG-Browser early gesetzt (vor hcap-ready);
    // window.isLG wird erst nach DeviceType.isLG() gesetzt → Timing-Problem
    if(window.isLG || window.lgVersion) return DEVICE_TYPE.LG;
    // Direkte hcap-Prüfung falls window.isLG noch nicht gesetzt (Timing-Problem beim Start)
    try {
      if(typeof hcap !== 'undefined' && hcap && hcap.API_VERSION) return DEVICE_TYPE.LG;
    } catch(e) { /* hcap nicht verfügbar */ }
    if(window.isOrsay) return DEVICE_TYPE.ORSAY;
    return DEVICE_TYPE.DEFAULT;
  }

  static get model() {
    console.log("=====================================model-", this.type);
    switch (this.type) {
      case DEVICE_TYPE.TIZEN:
        return Tizen.getModel;
      case DEVICE_TYPE.ORSAY:
        return Orsay.getModel;
        //return DEVICE_TYPE.ORSAY;
      case DEVICE_TYPE.LG:
        return LG.getModel();
      default:
        return DEVICE_TYPE.DEFAULT;
    }
  }

  static get version() {
    console.log("=====================================version-", this.type);
    switch (this.type) {
      case DEVICE_TYPE.TIZEN:
        return Tizen.getVersion;
      case DEVICE_TYPE.ORSAY:
        return Orsay.getVersion;
        //return DEVICE_TYPE.ORSAY;
      case DEVICE_TYPE.LG:
        return LG.getVersion();
      default:
        return DEVICE_TYPE.DEFAULT;
    }
  }

  //static async mac() {
  static get mac() {
    console.log("=====================================mac-", this.type);
    switch (this.type) {
      case DEVICE_TYPE.TIZEN:
        return Tizen.getMac;
      case DEVICE_TYPE.ORSAY:
        return Orsay.getMac;
      case DEVICE_TYPE.LG:
        return LG.getMac();
      default:
        return '00:00:00:00:00';
    }
  }

  //static async ip() {
  static get ip() {
    console.log("=====================================ip-", this.type);
    switch (this.type) {
      case DEVICE_TYPE.TIZEN:
        return Tizen.getIP;
      case DEVICE_TYPE.ORSAY:
        return Orsay.getIP;
      case DEVICE_TYPE.LG:
        return LG.getIP();
      default:
        return '0.0.0.0';
    }
  }

  static get firmware() {
    console.log("=====================================firmware-", this.type);
    switch (this.type) {
      case DEVICE_TYPE.TIZEN:
        return Tizen.getFirmware;
      case DEVICE_TYPE.ORSAY:
        return Orsay.getFirmware;
      case DEVICE_TYPE.LG:
        return LG.getFirmware();
      default:
        return window.navigator.userAgent;
    }
  }

  static get platform() {
    console.log("=====================================platform-", this.type);
    switch (this.type) {
      case DEVICE_TYPE.TIZEN:
        return Tizen.getPlatform;
      case DEVICE_TYPE.ORSAY:
        return Orsay.getPlatform;
      case DEVICE_TYPE.LG:
        return LG.getPlatform();
      default:
        return window.navigator.userAgent;
    }
  }

  static get serialNumber() {
    console.log("=====================================serialNumber-", this.type);
    switch (this.type) {
      case DEVICE_TYPE.TIZEN:
        return Tizen.getSerial;
      case DEVICE_TYPE.ORSAY:
        return Orsay.getSerial;
      case DEVICE_TYPE.LG:
        return LG.getSerial();
      default:
        return uuidv4();
    }
  }

  static get resolutionHeight() {
    console.log("=====================================resolutionHeight-", this.type);
    switch (this.type) {
      case DEVICE_TYPE.TIZEN:
        return Tizen.getResolutionHeight();
      case DEVICE_TYPE.ORSAY:
        return Orsay.getResolution;
      case DEVICE_TYPE.LG:
        return LG.getResolutionHeight;
      default:
        return screen.height;
    }
  }

  static get resolutionWidth() {
    console.log("=====================================resolutionWidth-", this.type);
    switch (this.type) {
      case DEVICE_TYPE.TIZEN:
        return Tizen.getResolutionWidth();
      case DEVICE_TYPE.ORSAY:
        return Orsay.getResolution;
      case DEVICE_TYPE.LG:
        return LG.getResolutionWidth;
      default:
        return screen.width;
    }
  }

  static reboot() {
    switch (this.type) {
      case DEVICE_TYPE.TIZEN:
        Tizen.reboot();
      case DEVICE_TYPE.ORSAY:
        Orsay.reboot();
      case DEVICE_TYPE.LG:
        LG.reboot();
      default:
        console.log(
          '  [ERROR]: Reboot not supported for DEVICE_TYPE: ',
          this.type
        );
    }
  }
  static turnOff() {
    switch (this.type) {
      case DEVICE_TYPE.TIZEN:
        Tizen.turnOff();
        break;
      case DEVICE_TYPE.ORSAY:
        Orsay.turnOff();
        break;
      case DEVICE_TYPE.LG:
        LG.turnOff();
        break;
      default:
        console.log(
          '  [ERROR]: Turn Off not supported for DEVICE_TYPE: ',
          this.type
        );
    }
  }
  static turnOn() {
    switch (this.type) {
      case DEVICE_TYPE.TIZEN:
        Tizen.turnOn();
        break;
      case DEVICE_TYPE.ORSAY:
        Orsay.turnOn();
        break;
      case DEVICE_TYPE.LG:
        LG.turnOn();
        break;
      default:
        console.log(
          '  [ERROR]: Turn On not supported for DEVICE_TYPE: ',
          this.type
        );
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/Device/index.js